import * as React from 'react';
import { Button, ButtonProps } from 'antd';

import s from './index.module.less';
import { useTranslation } from 'next-i18next';

export default function FetchMoreButton(props: ButtonProps) {
  const { t: tLayout } = useTranslation('layout');

  return (
    <div className={s.pagination}>
      <Button size="large" type="primary" className={s.paginationBtn} {...props}>
        {tLayout('load_more')}
      </Button>
    </div>
  );
}
